import {getMaintainPlantKmsUrl} from '@hconnect/common/utils'
import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {SxProps, Theme} from '@mui/material'
import {KilnMonitoringDataWidget, useKilnMonitoringState} from '@widgets/kms'
import React from 'react'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
  onSelectedKilnChange?: () => void
}

export const KilnStatusMonitoringContainer: React.FC<Props> = ({
  plantId,
  cardBoxSx,
  placeholderWrapperSx,
  onSelectedKilnChange
}) => {
  const {selectedKiln} = useKilnMonitoringState(plantId)

  const linkPath = getMaintainPlantKmsUrl(plantId, selectedKiln?.id)

  return (
    <CardLinkWrapper href={linkPath} data-test-id="kiln-monitoring-link-to-maintain">
      <KilnMonitoringDataWidget
        plantId={plantId}
        cardBoxSx={cardBoxSx}
        placeholderWrapperSx={placeholderWrapperSx}
        onSelectedKilnChange={onSelectedKilnChange}
      />
    </CardLinkWrapper>
  )
}
